import { differenceInSeconds } from 'date-fns'
import formatDuration from 'app/functions/formatDuration'

export default ({ size = 'big', seconds = 0, currentDisplay }) => {
  return (
    <div className={`digital-display-wrapper digital-display-wrapper-${size}`}>
      <div
        className={clsx('digital-display', {
          'digital-display-negative': seconds < 0
        })}
      >
        {currentDisplay}
      </div>
    </div>
  )
}
